module.exports = {
    "userQuotas": "/api/bm/getUserQuotas", //查询用户配额
    "addBandwidthPackageToCar": "/api/cps/bandwidthPackages/addBandwidthPackageToCar", //创建共享带宽订单
};



// WEBPACK FOOTER //
// ./src/api/sbw/create/config.js